import { OrderApiClient } from '@fourthwall/services/dist/OrderApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useGetFulfillmentsCSVMutation = createMutationHook(OrderApiClient.getFulfillmentsCSV, {
  mutationKey: ['getFulfillmentsCSV'],
})
